import { t } from 'services/translation';

export default {
  first_name: {
    presence: { allowEmpty: false },
  },
  last_name: {
    presence: { allowEmpty: false },
  },
  email: {
    presence: { allowEmpty: false },
    email: true,
  },
  cardholder_first_name: {
    presence: { allowEmpty: false },
  },
  cardholder_last_name: {
    presence: { allowEmpty: false },
  },
  billing_address_line_1: {
    presence: { allowEmpty: false },
  },
  billing_country: {
    presence: { allowEmpty: false },
  },
  billing_city: {
    presence: { allowEmpty: false },
  },
  billing_region: {
    presence: { allowEmpty: false },
  },
  billing_zip_code: {
    presence: { allowEmpty: false },
  },
  waiver_accepted: {
    isChecked: { message: `^${t('TERMS_AND_CONDITIONS_SHOULD_BE_ACCEPTED')}` },
  },
  anyroad_privacy_policy: {},
  privacy_policy_accepted: {
    isChecked: { message: `^${t('PRIVACY_POLICY_SHOULD_BE_ACCEPTED')}` },
  },
  checkout_questions: {
    checkoutQuestions: { fullMessage: false },
  },
  phone: {
    presence: { allowEmpty: false },
  },
  cardNumber: true,
  cardExpiry: true,
  cardCvc: true,
};
